import classNames from 'class-names';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Form, Overlay, Tooltip } from 'react-bootstrap';

import { Switch } from '../../Atoms/Switch';

const FormSwitch = ({
  name,
  label = '',
  groupClassName = '',
  helpText,
  errorDisplayMode = 'inline',
  errorTooltipPlacement = 'top',
  ...props
}) => {
  const tooltipOverlayTarget = useRef(null);
  const [field, { touched, error }] = useField({
    ...props,
    name,
    type: 'checkbox',
  });
  const isInvalid = touched && error;

  return (
    <Form.Group controlId={name} className={groupClassName}>
      <div className="d-inline-flex">
        <Switch {...props} {...field} ref={tooltipOverlayTarget} />

        {label && (
          <Form.Label
            className={classNames('ml-2', {
              'text-danger': isInvalid,
            })}
          >
            {label}
          </Form.Label>
        )}
      </div>

      <Overlay
        target={tooltipOverlayTarget.current}
        show={isInvalid && errorDisplayMode === 'tooltip'}
        placement={errorTooltipPlacement}
      >
        <Tooltip className="tooltip-red">{error}</Tooltip>
      </Overlay>

      {isInvalid && errorDisplayMode === 'inline' && (
        <Form.Control.Feedback className="d-flex" type="invalid">
          {error}
        </Form.Control.Feedback>
      )}

      {helpText && <Form.Text muted>{helpText}</Form.Text>}
    </Form.Group>
  );
};

FormSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  groupClassName: PropTypes.string,
  helpText: PropTypes.string,
  errorDisplayMode: PropTypes.oneOf(['inline', 'tooltip']),
  errorTooltipPlacement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default FormSwitch;
